import React, { useState } from 'react'
import { H4, Text } from '../../../../../../../../Styles/typography'
import { ParticipantsEl } from './Elements'
import { Tab, Tabs } from '@material-ui/core'
import RegisteredTab from './Components/RegisteredTab'
import RequestTab from './Components/RequestTab'
import BatchTimingsStore from '../../Stores/BatchTimingsStore'
import ComponentLoader from '../../../../../../../../Components/Loading/ComponentLoader'

function Participants() {
  const [tabValue, setTabValue] = useState(0)

  const {
    userType,
    batchId,
    loading,
    loadFailed,
    batchTimings: { registrations, requests } = {},
  } = BatchTimingsStore.useContainer()

  return (
    <ParticipantsEl>
      <H4>Batch Participants</H4>

      {userType === 'teacher' && (
        <div className='tabs'>
          <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)}>
            <Tab
              label={`Registered${
                !!registrations ? ` (${registrations.length})` : ''
              }`}
            />
            <Tab
              label={`Requests${!!requests ? ` (${requests.length})` : ''}`}
            />
          </Tabs>
        </div>
      )}
      <div className='tabPanel'>
        {!batchId ? (
          <Text>Select a batch to view participants</Text>
        ) : (
          <ComponentLoader loading={loading} loadFailed={loadFailed}>
            {(() => {
              switch (tabValue) {
                case 0:
                  return (
                    <>
                      {registrations?.map((reg) => (
                        <RegisteredTab data={reg} key={`regTab-${reg.id}`} />
                      ))}
                    </>
                  )
                case 1:
                  return (
                    <>
                      {requests?.map((req) => (
                        <RequestTab data={req} key={`reqTab-${req.id}`} />
                      ))}
                    </>
                  )
                default:
                  return null
              }
            })()}
          </ComponentLoader>
        )}
      </div>
    </ParticipantsEl>
  )
}

export default Participants
